export default __webpack_public_path__ + "static/media/become.1eed8eb7.png";